<template>
  <div class="tw-flex tw-h-screen tw-flex-col">
    <!-- Mobile layout -->
    <div class="tw-flex tw-h-full tw-flex-col sm:tw-hidden">
      <!-- Fixed CaseWise logo header -->
      <div class="safe-area-top" :class="headerNav">
        <div class="tw-flex tw-w-full tw-items-center tw-justify-center tw-py-4">
          <CaseWiseHeaderLogo />
        </div>
      </div>

      <!-- Scrollable content -->
      <div class="tw-flex-1 tw-overflow-auto" :class="headerNav">
        <!-- White container with rounded top -->
        <div class="tw-flex tw-min-h-full tw-flex-col">
          <div class="tw-flex tw-flex-1 tw-flex-col tw-rounded-t-[30px] tw-bg-white">
            <div class="tw-pt-8">
              <img
                :src="cobrandedLogoUrl"
                :alt="branding.name"
                class="tw-mx-auto tw-h-auto tw-max-h-10 tw-max-w-[256px]"
              />
              <slot name="mobile-form" />
            </div>
            <div class="tw-mt-auto">
              <SiteFooter :theme="authFooter" class="sm:tw-hidden" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop and tablet layout -->
    <div class="tw-hidden tw-h-full tw-w-full sm:tw-flex">
      <!-- Left side - Branding -->
      <div
        class="tw-flex tw-h-full tw-w-1/2 tw-flex-col tw-items-center tw-justify-center tw-bg-gradient-to-t"
        :class="[cobrandedExperience ? linearGradient : 'tw-bg-white']"
      >
        <Component
          :is="cobrandedExperience ? CaseWiseLoginLogo : 'img'"
          :src="!cobrandedExperience ? cobrandedLogoUrl : undefined"
          :alt="cobrandedExperience ? branding.name : 'CaseWise'"
          class="tw-h-auto tw-w-[256px] lg:tw-w-[430px] lg:tw-max-w-[430px]"
        />
      </div>

      <!-- Right side - Auth components -->
      <div
        class="tw-flex tw-h-full tw-w-1/2 tw-flex-col tw-items-center tw-justify-center tw-bg-gradient-to-t"
        :class="[cobrandedExperience ? 'tw-bg-white' : linearGradient, 'tw-py-6']"
      >
        <slot name="form" />
      </div>
    </div>

    <!-- Desktop footer -->
    <SiteFooter
      class="tw-relative tw-mt-auto tw-hidden tw-w-full sm:tw-block"
      :theme="authFooter"
    />
    <AppToast />
  </div>
</template>

<script setup lang="ts">
import CaseWiseHeaderLogo from '~/assets/icons/CaseWiseHeaderLogo.svg'
import CaseWiseLoginLogo from '~/assets/icons/CaseWiseLoginLogo.svg'

const { getThemeToken, getThemeTokenString } = useTheme()
const authFooter = getThemeToken('auth-footer')
const linearGradient = getThemeToken('linear-gradient')
const headerNav = getThemeTokenString('header-nav')

const branding = useBrand()
const cobrandedExperience = computed(() => branding.value.brandingExperience === 'cobrand')

const cobrandedLogoUrl = computed(() => {
  return branding.value.svgLogoUrl || branding.value.pngLogoUrl
})
</script>

<style scoped>
.safe-area-top {
  padding-top: calc(env(safe-area-inset-top) - 18px);
}

.safe-area-bottom {
  padding-bottom: calc(env(safe-area-inset-bottom) / 3);
}
</style>
